module.exports = __webpack_public_path__ + "static/media/copy_icon.75f36d7a.svg";